import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WebClient } from '@injectables';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { Shift } from '../../../../../../shared-models/public/shift';
import { ShiftEditDialogComponent } from '@app/shared/edit-dialog/shift/shift-edit-dialog.component';
import { op } from '@lib/rxjs';
import { Subscription } from 'rxjs';
import { ModalFilter } from '@app/shared/model-table/model-table-filter';
import { ModelTableComponent } from '@app/shared/model-table/model-table.component';

@Component({
    selector: 'shifts',
    templateUrl: './shifts.component.html',
    styleUrls: ['./shifts.component.scss']
})
export class ShiftsComponent implements OnInit, OnDestroy {
    constructor(
        private readonly webClient: WebClient,
        private readonly fragQuery: FragQueryService,
    ) { };

    @ViewChild(ModelTableComponent)
    private modelTable: ModelTableComponent<Shift, WebClient.RestTypes>;

    private readonly subscriptions: Subscription = new Subscription();
    public readonly devices$ = this.fragQuery.devices$;
    public readonly device$ = this.fragQuery.device$;
    public readonly deviceUuid$ = this.fragQuery.deviceUuid$;

    public readonly model = Shift;
    public readonly restClient = this.webClient.model.shift;
    public readonly editDialog = ShiftEditDialogComponent;
    public readonly where$ = this.device$.pipe(
        op.map((device) => {
            if (!device) {
                return null;
            }
            return { deviceId: device.id };
        })
    );

    public ngOnInit(): void {
        this.subscriptions.add(this.fragQuery.userSettingUpdated$.subscribe(() => this.refresh()));
    }

    public getEmails(emailCsv: string){
		return emailCsv !== null ? emailCsv.split(',') : null;
	}
    
    public refresh() {
        this.modelTable?.updateRecords();
    }

    public ngOnDestroy(): void {
        this.subscriptions?.unsubscribe();
    } 

    public filterConfigs: ModalFilter[] = [
        {
            type: 'input-string',
            column: 'Title',
            dbColumn: "title",
        },
        {
            type: 'input-string',
            column: 'Email',
            dbColumn: "emails",
        },
        {
            type: "select-string",
            column: "Quantity Type",
            dbColumn: "weightType",
            options: ["volume", "area"]
        },
        {
            type: "select-string",
            column: "Chart Type",
            dbColumn: "chartType",
            options: ["column", "line"]
        }
    ];
}
